/** Renders the privacy-policy text: lines starting with "## " become headings, blank lines split paragraphs. */
export function PolicyBody({ body }: { body: string }) {
  const blocks = body.split(/\n{2,}/).map((b) => b.trim()).filter(Boolean);
  return (
    <div className="policy">
      {blocks.map((b, i) => {
        const lines = b.split('\n');
        const head = lines[0].startsWith('## ') ? lines.shift()!.slice(3) : null;
        return (
          <div key={i} className="policy-block">
            {head && <h3>{head}</h3>}
            {lines.length > 0 && <p>{lines.join('\n')}</p>}
          </div>
        );
      })}
    </div>
  );
}
